<nb-layout center>
  <nb-layout-column>
    <nb-card-body>
      <div class="logo"><img src="/assets/images/new_logo.svg" alt=""></div>

      <div *ngIf="title">
        <H2>{{ this.title }}</H2>

        <app-file-upload-dam [uploadURI]="uploadURI"/>

      </div>

      <div *ngIf="!title" class="empty"><h6>{{ translations.noResults }}</h6></div>

    </nb-card-body>
  </nb-layout-column>
</nb-layout>
